// 备课系统 word、ppt、excel文件预览
<template>
  <div class="office-preview">
    <div class="container-in clearfix">
      <div class="iframe-wrap clearfix">
        <div class="hide-top"></div>
        <iframe
          id="iframe"
          v-if="!isLarge"
          :src="url | httpToHttps"
          frameborder="0"
          width="906px"
          height="690px"
          allowfullscreen="true"
        >
        </iframe>
        <!-- <div class="hide-bottom"></div> -->
        <div class="max-size" v-if="isLarge">文件过大，无法预览，请下载！</div>
      </div>
    </div>
  </div>
</template>
<script>

import {
  bkResource,
  zipResource
} from '@/utils/constant'
import { md5Encrypt } from '@/utils/tools'
export default {
  name: 'c-office-preview',
  props: {
    file: {
      type: Object,
      default() {
        return {}
      }
    },
    fileUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      url: ''
    }
  },
  mounted () {
    this.geturl();
  },
  computed: {
    // 文件超过20M无法预览
    isLarge() {
      if (this.file.size !== '') {
        if (this.file.size > 20 * 1024) {
          return true
        } else {
          return false
        }
      }
      //  return false
    },
    showDocShadow() {
      if (this.file.suffixType === 'doc' || this.file.suffixType === 'docx') {
        return true
      } else {
        return false
      }
    },
    showPptShadow() {
      if (this.file.suffixType === 'ppt' || this.file.suffixType === 'pptx') {
        return true
      } else {
        return false
      }
    },
    showExcelShadow() {
      if (this.file.suffixType === 'xls' || this.file.suffixType === 'xlsx') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    geturl() {
      let random = Math.random().toString(36).substring(3, 13);
      let filename = 'filename' + new Date().getTime() + random;
      let newBaseUrl = 'https://view.officeapps.live.com/op/view.aspx?src='

      if (this.file.type === 'document') {
        this.url = newBaseUrl + encodeURIComponent(zipResource +`${this.file.id}/preview/${filename || 'filename'}.${this.file.suffixType}`)
      }
      else {
        this.url = newBaseUrl + encodeURIComponent(bkResource + `${this.file.id}/preview/${filename || 'filename'}.${this.file.suffixType}`)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.office-preview {
  position: relative;
  z-index: 10;
  height: 690px;
  overflow: hidden;
  background: rgba(255, 255, 255, 1);
}
.iframe-wrap {
  position: relative;
  height: 690px;

  .hide-top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 90px;
    z-index: 1;
    background: #fff;
  }

  // #iframe {
  //   margin-top: -90px;
  // }

  .hide-bottom {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 200px;
    height: 24px;
    z-index: 1;
  }
}
.shade-doc {
  position: absolute;
  right: 1px;
  bottom: 1px;
  width: 284px;
  height: 20px;
  background-color: #f0f2f1;
}
.shade-ppt {
  position: absolute;
  right: 42px;
  bottom: 0px;
  width: 210px;
  height: 22px;
  background: #424242;
}
.shade-excel {
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 22px;
  background-color: #f3f2f1;
}
.clearfix::after {
  content: '';
  display: block;
  clear: both;
}
.max-size {
  font-size: 18px;
}
.wrapper {
  position: absolute;
  right: 30px;
  top: 90px;
  height: 578px;
  width: 814px;
  background-color: transparent;
  z-index: 99999;
}
#GiveFeedback {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/previewV2/components/COfficePreview.vue